import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { hydrate } from 'react-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from 'env/theme'
import App from './App'

hydrate(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById('root'),
)

if (module.hot) {
  module.hot.accept()
}
